import { useState, useCallback, useEffect } from "react";
import Sidebar from "./components/Sidebars";
import { Outlet } from "react-router-dom";

// API base (diambil dari Sidebar.jsx)
const API_BASE = (process.env.REACT_APP_API_BASE || "/api").replace(/\/+$/, "");

export default function Layout() {
  const [layersData, setLayersData] = useState({});
  const [activeLayerIds, setActiveLayerIds] = useState({});
  const [photoRefreshKey, setPhotoRefreshKey] = useState(0);
  const [layersRefreshKey, setLayersRefreshKey] = useState(0); 
  const [mapFocusTarget, setMapFocusTarget] = useState(null);

  // --- TAMBAHKAN STATE DAN LOGIKA FOLDER DI SINI ---
  const [folders, setFolders] = useState({});
  const [foldersLoading, setFoldersLoading] = useState(false);
  const token = localStorage.getItem("token") || "";

  const [panoramas, setPanoramas] = useState({});
  const [panoramasLoading, setPanoramasLoading] = useState(false);

  const loadPanoramas = useCallback(async () => {
    try {
      setPanoramasLoading(true);
      // Asumimos un endpoint que devuelve TODOS los panoramas
      const res = await fetch(`${API_BASE}/panorama_locations`, {
        headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      });
      if (!res.ok) throw new Error(`Failed to load panorama locations`);
      const data = await res.json();
      const panoData = Array.isArray(data) ? data : [];

      // Agrupamos por project_id, igual que los folders
      const groupedByProject = {};
      panoData.forEach((pano) => {
        const projectId = pano.project_id;
        if (!groupedByProject[projectId]) {
          groupedByProject[projectId] = [];
        }
        groupedByProject[projectId].push(pano);
      });

      setPanoramas(groupedByProject);
    } catch (e) {
      console.error(e.message || "Failed to load panorama locations");
    } finally {
      setPanoramasLoading(false);
    }
  }, [token]);

  useEffect(() => {
    loadPanoramas();
  }, [loadPanoramas]);

  // Función para refrescar los datos si es necesario (ej: después de crear/editar)
  const refreshPanoramas = useCallback(() => {
    loadPanoramas();
  }, [loadPanoramas]);

  const loadFolders = useCallback(async () => {
    try {
      setFoldersLoading(true);
      const res = await fetch(`${API_BASE}/photo_locations`, {
        headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      });
      if (!res.ok) throw new Error(`Failed to load folders`);
      const data = await res.json();
      const foldersData = Array.isArray(data) ? data : [];

      const groupedByProject = {};
      foldersData.forEach((folder) => {
        const projectId = folder.project_id;
        if (!groupedByProject[projectId]) {
          groupedByProject[projectId] = [];
        }
        groupedByProject[projectId].push(folder);
      });

      setFolders(groupedByProject);
    } catch (e) {
      console.error(e.message || "Failed to load folders");
    } finally {
      setFoldersLoading(false);
    }
  }, [token]);

  // Panggil loadFolders saat komponen pertama kali mount
  useEffect(() => {
    loadFolders();
  }, [loadFolders]);

  // Fungsi yang akan dipanggil dari Sidebar untuk me-refresh data folder
  const refreshFolders = useCallback(() => {
    loadFolders();
  }, [loadFolders]);
  // --- AKHIR PENAMBAHAN ---

  const onLayersChanged = useCallback(({ type, newLayer, layerId, projectId, layers }) => {
    switch (type) {
      case 'load':
        setLayersData(prev => ({
          ...prev,
          [projectId]: layers,
        }));
        setActiveLayerIds(prev => {
          const newActive = { ...prev };
          layers.forEach(layer => {
            newActive[layer.id] = true;
          });
          return newActive;
        });
        break;
      case 'add':
        setLayersData(prev => ({
          ...prev,
          [projectId]: [...(prev[projectId] || []), newLayer],
        }));
        setActiveLayerIds(prev => ({
          ...prev,
          [newLayer.id]: true,
        }));
        setLayersRefreshKey(prev => prev + 1); 
        break;
      case 'delete':
        setLayersData(prev => {
          const newLayers = { ...prev };
          if (newLayers[projectId]) {
            newLayers[projectId] = newLayers[projectId].filter(l => l.id !== layerId);
          }
          return newLayers;
        });
        setActiveLayerIds(prev => {
          const newActive = { ...prev };
          delete newActive[layerId];
          return newActive;
        });
        setLayersRefreshKey(prev => prev + 1); 
        break;
      default:
        setActiveLayerIds(prev => ({ ...prev }));
        break;
    }
  }, []);

    const onPhotoDataChanged = useCallback(() => {
    setPhotoRefreshKey(prev => prev + 1);
  }, []);

  

  const toggleLayerVisibility = useCallback((layerId) => {
    setActiveLayerIds(prev => ({
      ...prev,
      [layerId]: !prev[layerId],
    }));
  }, []);

  const requestMapFocus = useCallback((target) => {
    if (!target) return;
    setMapFocusTarget({
      ...target,
      requestId: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    });
  }, []);

  const clearMapFocusTarget = useCallback(() => {
    setMapFocusTarget(null);
  }, []);

return (
    <div className="d-flex min-vh-100">
      <Sidebar
      folders={folders}
        foldersLoading={foldersLoading}
        refreshFolders={refreshFolders}
        onLayersChanged={onLayersChanged}
        onPhotoDataChanged={onPhotoDataChanged}
        activeLayerIds={activeLayerIds}
        toggleLayerVisibility={toggleLayerVisibility}
        panoramas={panoramas}
        panoramasLoading={panoramasLoading}
        refreshPanoramas={refreshPanoramas}
        onMapFocusRequest={requestMapFocus}
      />
      <main className="flex-grow-1 p-3">
        <Outlet context={{ 
          dataLayers: layersData, 
          activeLayerIds, 
          photoRefreshKey,
          layersRefreshKey,
          folders,
          panoramas,
          mapFocusTarget,
          clearMapFocusTarget,
        }} />     
      </main>
    </div>
  );
}



